import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Limited Fitment Filter',
  name: 'fitmentFilter',
  type: 'document',
  fields: [
    defineField({
      title: 'Limited Fitment Filter Name',
      name: 'name',
      type: 'string',
      description: 'Use this to identify this filter in the Sanity Admin.',
    }),
    defineField({
      title: 'Label',
      name: 'label',
      type: 'string',
    }),
    defineField({
      title: 'Dropdown Label',
      name: 'dropdownLabel',
      type: 'string',
    }),
    defineField({
      title: 'Options',
      name: 'options',
      type: 'array',
      of: [{ type: 'string' }],
    }),
    defineField({
      title: 'Design not available tooltip',
      name: 'designNotAvailableTooltip',
      type: 'string',
      initialValue: 'Design not available',
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'Fitment Filter' }) {
      return {
        title,
        subtitle: 'Fitment Filter',
      }
    },
  },
})
